import { SxStyleProp } from 'theme-ui';

export const baseStyle: { [k: string]: SxStyleProp } = {
  iconContainer: {
    width: ['28px', '78px'],
    height: ['28px', '78px'],
    backgroundColor: 'rgba(255, 255, 255, 0.3)',
    border: '2px solid white',
    borderRadius: '50%',
    alignItems: 'center',
    justifyContent: 'center',
  },
  icon: {
    width: '0',
    height: '0',
    borderTop: ['6px solid transparent', '16px solid transparent'],
    borderBottom: ['6px solid transparent', '16px solid transparent'],
    borderLeft: ['9px solid white', '24px solid white'],
    marginLeft: ['2px'],
  },
};
